<template>
    <div>
        <h1 v-if="obData.messages" class="def-header-2">{{obData.messages.title}}</h1>
        <div class="page-news__grid">
            <news-card v-for="item in obData.items" :result="item" :key="item.id" :messages="obData.messages" />
        </div>
        <Pagination
            :result="obData.pagination"
            @change="getPage"
            @addMore="addMore"
        />
    </div>
</template>

<script>
    export default {
        name: 'page-news',
        selector: '.page-news',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "items": [
                        {
                            "id": 57867,
                            "name": "Porro voluptatum et quae quo non id ea eligendi.",
                            "detailPage": "/news/porro-voluptatum-et-quae-quo-non-id-ea-eligendi/",
                            "previewText": "Ullam animi voluptas quam ullam totam sunt doloremque. Est repudiandae numquam officiis repellendus unde. In dolor repellat possimus placeat. Velit rerum labore nam labore laudantium enim aut. Laboriosam nemo qui a explicabo ut minus. Molestiae adipisci culpa est temporibus reiciendis ut. Consectetur ut omnis architecto sit ducimus excepturi mollitia. Dolorem autem deleniti eius sed id expedita aut mollitia.",
                            "article": 57867,
                            "picture": {
                                "alt": "Porro voluptatum et quae quo non id ea eligendi.",
                                "src": "/upload/resize_cache/iblock/1ea/200_200_140cd750bba9870f18aada2478b24840a/1ea07814cd003707553e1c75ce758e78.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57867"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57871,
                            "name": "Sit possimus eos doloremque qui.",
                            "detailPage": "/news/sit-possimus-eos-doloremque-qui/",
                            "previewText": "Eius libero occaecati voluptas voluptatem. Consequatur quibusdam esse delectus dolore. Perferendis nesciunt iusto aut possimus laborum. Est totam eos ut repudiandae voluptatibus. Sint ut non non ea quis. Eos et et voluptas. Sit fugiat fugit et odio totam eum.",
                            "article": 57871,
                            "picture": {
                                "alt": "Sit possimus eos doloremque qui.",
                                "src": "/upload/resize_cache/iblock/078/200_200_140cd750bba9870f18aada2478b24840a/078230b53ec0500c04707e053e1c0b3f.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57871"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57851,
                            "name": "Dolorem expedita esse fugit ducimus.",
                            "detailPage": "/news/dolorem-expedita-esse-fugit-ducimus/",
                            "previewText": "Omnis fuga qui illum sit voluptatem. Eum optio non at quam dolorem ea error. Nostrum enim minima molestiae et aut dolorem est. Aliquam sed eum deleniti necessitatibus magni.",
                            "article": 57851,
                            "picture": {
                                "alt": "Dolorem expedita esse fugit ducimus.",
                                "src": "/upload/resize_cache/iblock/5fa/200_200_140cd750bba9870f18aada2478b24840a/5fa5de29a2f23ae6d80cb580c2d085f4.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57851"
                            },
                            "date": "10/25/2020 09:19:37 pm"
                        },
                        {
                            "id": 57838,
                            "name": "Vel tempora inventore magni aut eaque temporibus.",
                            "detailPage": "/news/vel-tempora-inventore-magni-aut-eaque-temporibus/",
                            "previewText": "Eos non distinctio voluptas expedita. Officiis soluta eum at exercitationem. Doloribus qui doloremque quod ut. Velit omnis adipisci repellat distinctio. Eligendi tempore quam repellat totam architecto. Non eum dignissimos velit provident quasi sed eos quo. Quas porro perspiciatis sint odio aut rerum beatae. Nemo aut minus quis debitis reiciendis est. Ducimus nesciunt officiis iusto corporis vel nostrum.",
                            "article": 57838,
                            "picture": {
                                "alt": "Vel tempora inventore magni aut eaque temporibus.",
                                "src": "/upload/resize_cache/iblock/05d/200_200_140cd750bba9870f18aada2478b24840a/05dc5cd9ba9d5773d39b8dad3c3f981d.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57838"
                            },
                            "date": "10/25/2020 09:19:36 pm"
                        },
                        {
                            "id": 57853,
                            "name": "Quia doloremque quia impedit dolorum iste.",
                            "detailPage": "/news/quia-doloremque-quia-impedit-dolorum-iste/",
                            "previewText": "Sapiente accusantium odit quis magnam qui. Ab fuga vel odit qui exercitationem qui nesciunt. Quis ea commodi ducimus ipsam qui. Id quasi et quos natus amet quis excepturi. Temporibus officia assumenda pariatur dolor magni tempore et. Modi aut odit debitis rem repudiandae iste voluptatem perferendis. Molestiae minus esse at officiis alias.",
                            "article": 57853,
                            "picture": {
                                "alt": "Quia doloremque quia impedit dolorum iste.",
                                "src": "/upload/resize_cache/iblock/6f3/200_200_140cd750bba9870f18aada2478b24840a/6f3c9a18fb440cfeec1d7e5dc10aea49.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57853"
                            },
                            "date": "10/25/2020 09:19:37 pm"
                        },
                        {
                            "id": 57891,
                            "name": "Veniam animi eos sapiente voluptatem recusandae qui voluptatem similique.",
                            "detailPage": "/news/veniam-animi-eos-sapiente-voluptatem-recusandae-qui-voluptatem-similique/",
                            "previewText": "Alias laudantium atque quae qui eum ea quas. Quo odit non et consequatur dolorem. Deleniti occaecati facilis nesciunt vero et. Optio qui quibusdam qui eum.",
                            "article": 57891,
                            "picture": {
                                "alt": "Veniam animi eos sapiente voluptatem recusandae qui voluptatem similique.",
                                "src": "/upload/resize_cache/iblock/5f1/200_200_140cd750bba9870f18aada2478b24840a/5f13adf8674b1207634a65d9bb53fc10.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57891"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57882,
                            "name": "Pariatur pariatur veritatis totam autem dolor.",
                            "detailPage": "/news/pariatur-pariatur-veritatis-totam-autem-dolor/",
                            "previewText": "Molestiae labore totam debitis reiciendis. Dolores aut voluptatem soluta voluptas pariatur nobis saepe maiores.",
                            "article": 57882,
                            "picture": {
                                "alt": "Pariatur pariatur veritatis totam autem dolor.",
                                "src": "/upload/resize_cache/iblock/603/200_200_140cd750bba9870f18aada2478b24840a/603fc8bcd81bc03157502a9bff225c6c.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57882"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57883,
                            "name": "Non consequatur velit quia nobis facilis provident nobis.",
                            "detailPage": "/news/non-consequatur-velit-quia-nobis-facilis-provident-nobis/",
                            "previewText": "Vero magni natus impedit ut ab dolorem ut. Ut vitae ex placeat magni quis doloremque sint. Est sunt ut velit corrupti at. Sit eligendi et exercitationem quo cumque. Recusandae dolor enim ut quos. Minus facere ratione blanditiis ea ea. Quos quam vitae consectetur et reprehenderit totam commodi quis.",
                            "article": 57883,
                            "picture": {
                                "alt": "Non consequatur velit quia nobis facilis provident nobis.",
                                "src": "/upload/resize_cache/iblock/941/200_200_140cd750bba9870f18aada2478b24840a/94195159a6457565af5bacf346e75099.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57883"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57897,
                            "name": "Illum et et commodi facere aspernatur ipsa.",
                            "detailPage": "/news/illum-et-et-commodi-facere-aspernatur-ipsa/",
                            "previewText": "Illum dignissimos aspernatur et totam eveniet. Autem hic et voluptatem qui magnam. Eum optio libero quae quia a. Debitis minus architecto sed saepe sequi. Non perferendis corrupti voluptas animi nam. Laboriosam et rerum numquam sit voluptatem. Odio sint repudiandae recusandae voluptatem illo cupiditate. Et et eos et eius omnis.",
                            "article": 57897,
                            "picture": {
                                "alt": "Illum et et commodi facere aspernatur ipsa.",
                                "src": "/upload/resize_cache/iblock/9ac/200_200_140cd750bba9870f18aada2478b24840a/9ac1d08e85882194f54fb9f2bbd0536d.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57897"
                            },
                            "date": "10/26/2020 02:12:04 am"
                        },
                        {
                            "id": 57870,
                            "name": "Possimus temporibus maxime quos velit eveniet.",
                            "detailPage": "/news/possimus-temporibus-maxime-quos-velit-eveniet/",
                            "previewText": "Tempore eligendi dolor omnis dolore. Eaque debitis sed consequuntur aliquam et provident sed et. Enim inventore consequuntur cupiditate nemo. Saepe voluptatem quos pariatur labore nisi reiciendis dolorem ut. Veritatis et praesentium tempore ipsam ducimus. Corrupti qui cum et. Dolores recusandae velit quo ducimus. Soluta provident dolorum aliquid aut culpa sapiente.",
                            "article": 57870,
                            "picture": {
                                "alt": "Possimus temporibus maxime quos velit eveniet.",
                                "src": "/upload/resize_cache/iblock/d58/200_200_140cd750bba9870f18aada2478b24840a/d5825ed0b239e238bece2f32829c2cb1.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57870"
                            },
                            "date": "10/26/2020 02:12:03 am"
                        },
                        {
                            "id": 57855,
                            "name": "Aspernatur sit quos atque aut sint ea.",
                            "detailPage": "/news/aspernatur-sit-quos-atque-aut-sint-ea/",
                            "previewText": "Modi mollitia autem laboriosam velit qui nesciunt. Et aut nihil corrupti nobis expedita. Occaecati eligendi et dolore aut. Veniam earum dolorem atque mollitia ex. Soluta ad nam pariatur labore dolor iste accusantium culpa. Autem est dolorum eum.",
                            "article": 57855,
                            "picture": {
                                "alt": "Aspernatur sit quos atque aut sint ea.",
                                "src": "/upload/resize_cache/iblock/bbc/200_200_140cd750bba9870f18aada2478b24840a/bbc4bddf541776cbc4eb8ac781e2f9d9.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57855"
                            },
                            "date": "10/25/2020 09:19:37 pm"
                        },
                        {
                            "id": 57840,
                            "name": "Facere corporis voluptatum repudiandae at sunt.",
                            "detailPage": "/news/facere-corporis-voluptatum-repudiandae-at-sunt/",
                            "previewText": "Quo a dolores eum eveniet officia. Ratione ut quibusdam assumenda aut qui. Libero qui dolores eum voluptatum nam et. Consectetur quibusdam accusamus magni exercitationem distinctio magni. Quia nihil corrupti velit ipsum magni. Doloribus porro libero expedita esse velit qui voluptatem. Cumque et sed voluptatum sed nemo.",
                            "article": 57840,
                            "picture": {
                                "alt": "Facere corporis voluptatum repudiandae at sunt.",
                                "src": "/upload/resize_cache/iblock/817/200_200_140cd750bba9870f18aada2478b24840a/817a8bd7c66ca70a545f6c2fdd355895.jpeg"
                            },
                            "attributes": {
                                "id": "bx_3966226736_57840"
                            },
                            "date": "10/25/2020 09:19:37 pm"
                        }
                    ],
                    "pagination": {
                        "pagingKey": "PAGEN_1",
                        "pageCount": 6,
                        "pageNumber": 1,
                        "pageSize": 12
                    },
                    "messages": {
                        "title": "Новини",
                        "btnDetail": "Читати далі"
                    }
                })
            }
        },
        data() {
            return {
                obData: this.result
            }
        },
        methods: {
            /**
             * Тут происходит склеивание данных успешного ответа Ajax запроса
             */
            compareResponse(response){
                const data = response.data;

                if (this.debug) {
                    console.log('ajaxResponse', response);
                }

                for (let key in data.items) {
                    this.obData.items.push(data.items[key]);
                }

                this.obData.pagination = data.pagination;
            },
            /**
             * Имитация перехода на нужную страницу
             */
            replaceResponse(response){
                console.log(response.data);
                this.obData = response.data;
            },
            /**
             * Метод по которому происходит Ajax загрузка данных (добавление)
             */
            addMore () {
                if (this.obData.pagination.pageCount > this.obData.pagination.pageNumber) {
                    axios.get(window.location.href, {
                        params: {
                            api: 'y',
                            [this.obData.pagination.pagingKey]: ++this.obData.pagination.pageNumber,
                        }
                    })
                        .then(this.compareResponse)
                        .catch(function (error) {
                            console.log(error);
                        })
                        .then(function () {
                            console.log('always executed');
                        });

                }
            },
            /**
             * Метод по которому происходит Ajax переход на нужную страницу
             * @param numb
             */
            getPage(url) {
                axios.get(url, {
                    params: {
                        api: 'y',
                    }
                })
                    .then(this.replaceResponse)
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
    }
</script>

<style lang="scss">
    .page-news{
        &__grid{
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: 2px;
            @include point-lg{
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 40px;
                & > *:first-child{
                    grid-column-start: 1;
                    grid-column-end: 3;
                    .def-title-3{
                        font-size: rem(32);
                    }
                    .news-card__text{
                        font-size: rem(24);
                        min-height: 56px;
                        max-width: 850px;
                    }
                    .news-card__date{
                        font-size: rem(16);
                    }
                }
            }
        }
    }
</style>